import { css } from '@emotion/react';

const input = () => css`
  border: none;
  border-radius: 0.5rem;
  margin: 0 2rem 0 0;
  padding: 1rem;
  min-width: 40%;
  font-size: 1rem;
  text-align: center;
  box-shadow: inset 0px 0.35rem 0.35rem rgba(0, 0, 0, 0.25);

  ::placeholder {
    opacity: 0.8;
    font-weight: 500;
    color: var(--orange);
  }

  :focus-within {
    outline: none;
    box-shadow: inset 0px 0.35rem 0.35rem rgba(0, 0, 0, 0.25),
      0px 0px 2px 5px rgba(0, 0, 255, 0.25);

    ::placeholder {
      opacity: 0.4;
    }
  }
`;

export { input };
